import React from 'react';
import { Link } from 'react-router-dom';

const RustCratesOverviewPage = () => {
  return (
    <div className="page-shell">
      <div className="page-shell__content section-stack">
        <section className="section-card center-text">
          <div className="eyebrow">Crates.io Registry</div>
          <h1 className="page-title">Rust Crates</h1>
          <p className="page-copy" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            Open-source Rust crates I've developed and published on crates.io, designed for clean developer experience and utility. Select a crate below or from the navigation dropdown.
          </p>
        </section>

        <div className="three-column-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
          <section className="section-card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div className="eyebrow">Crate 01</div>
              <h2 className="section-title" style={{ fontSize: '1.8rem', marginBottom: '0.75rem' }}>cli-chat</h2>
              <p className="page-copy">
                A fast, lightweight Command Line Interface (CLI) for receiving and sending messages from the Ben's Chat parent project without opening a web browser. Built as a formal Finite State Automaton in Rust.
              </p>
            </div>
            <div style={{ marginTop: '1.5rem' }}>
              <Link to="/rust-crates/cli-chat" className="button-link">
                View cli-chat Page &rarr;
              </Link>
            </div>
          </section>

          <section className="section-card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div className="eyebrow">Crate 02</div>
              <h2 className="section-title" style={{ fontSize: '1.8rem', marginBottom: '0.75rem' }}>intense-pomodoro</h2>
              <p className="page-copy">
                A pomodoro timer that can scream at you to make work sessions feel more intense, accompanied by persistent skill journaling to track what you've learned over time.
              </p>
            </div>
            <div style={{ marginTop: '1.5rem' }}>
              <Link to="/rust-crates/intense-pomodoro" className="button-link">
                View intense-pomodoro Page &rarr;
              </Link>
            </div>
          </section>

          <section className="section-card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div className="eyebrow">Crate 03</div>
              <h2 className="section-title" style={{ fontSize: '1.8rem', marginBottom: '0.75rem' }}>cool_cli_input</h2>
              <p className="page-copy">
                An intuitive CLI input utility that captures inline input and automatically invokes your default editor (falling back to vim) when typing "vim" for longer text composition.
              </p>
            </div>
            <div style={{ marginTop: '1.5rem' }}>
              <Link to="/cli_input" className="button-link">
                View cool_cli_input Page &rarr;
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RustCratesOverviewPage;
